import type { CSSProperties } from "react"

const chevron = encodeURIComponent(
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="m7 10 5 5 5-5" stroke="#475569" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
)

/** Keeps native selects accessible while matching the inset card-form chevron. */
export const nativeSelectStyle: CSSProperties = {
	appearance: "none",
	WebkitAppearance: "none",
	backgroundImage: `url("data:image/svg+xml,${chevron}")`,
	backgroundRepeat: "no-repeat",
	backgroundPosition: "right 14px center",
	backgroundSize: "18px 18px",
	paddingRight: "46px"
}
